import {
  GenericError
} from "@auth0/auth0-spa-js";

export enum ERROR_CODES {
  USER_BLOCKED_IN_BAVEL = "2001",
  USER_BLOCKED_IN_AUTH0 = "2002",
  CLOCK_OUT_OF_SYNC = "2004",
  GENERIC_AUTH_ERROR = "2010"
}

export class AuthError {
  constructor(public readonly message: string, public readonly errorCode: string) {
  }

  static from(error: GenericError | Error): AuthError {
    if (error instanceof GenericError) {
      return this.fromGenericError(error);
    } else {
      return this.fromError(error);
    }
  }

  private static fromGenericError(error: GenericError): AuthError {
    if (error.error === "unauthorized") {
      return new AuthError(error.error_description, ERROR_CODES.USER_BLOCKED_IN_AUTH0);
    }
    const errorCode = this.getErrorCodeFromMessage(error.message);
    if (errorCode) {
      return new AuthError(error.message, errorCode);
    }

    return new AuthError(error.error_description, error.error);
  }

  private static fromError(error: Error): AuthError {
    if (error.message.includes("Expiration Time (exp) claim error in the ID token")) {
      return new AuthError("Your clock is out of sync. please correct it and try again.", ERROR_CODES.CLOCK_OUT_OF_SYNC);
    }
    const errorCode = this.getErrorCodeFromMessage(error.message);
    if (errorCode) {
      return new AuthError(error.message, errorCode);
    }

    return new AuthError(error.message, ERROR_CODES.GENERIC_AUTH_ERROR);
  }

  private static getErrorCodeFromMessage(message: string): string | null {
    const regex = /\(errorCode:\s*(\d+)\)/;
    const match = message.match(regex);
    return match ? match[1] : null;
  }
}
